import React from "react";
import { supportApi } from "../../services/supportApi";

const formatTime = (dateStr) => {
  const d = new Date(dateStr);
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const SupportMessage = ({ message, isAdmin }) => {
  const isMine = isAdmin ? message.is_admin : !message.is_admin;

  return (
    <div style={{
      display: "flex",
      justifyContent: isMine ? "flex-end" : "flex-start",
      marginBottom: "16px",
    }}>
      <div style={{ maxWidth: "70%" }}>
        {message.is_admin && (
          <div style={{
            fontSize: "10px", fontWeight: 700, color: "#6366f1",
            textTransform: "uppercase", letterSpacing: "0.06em",
            marginBottom: "4px", textAlign: isMine ? "right" : "left",
          }}>
            Support
          </div>
        )}

        <div style={{
          padding: "10px 14px",
          borderRadius: isMine ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
          background: isMine ? "#6366f1" : "#f3f4f6",
          color: isMine ? "#fff" : "#111827",
          fontSize: "13px",
          lineHeight: 1.55,
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}>
          {message.body}
        </div>

        {message.attachments?.length > 0 && (
          <div style={{
            marginTop: "6px",
            display: "flex", flexWrap: "wrap", gap: "4px",
            justifyContent: isMine ? "flex-end" : "flex-start",
          }}>
            {message.attachments.map((att) => (
              <a
                key={att.attachment_id}
                href={supportApi.getAttachmentUrl(message.ticket_id, att.attachment_id)}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-flex", alignItems: "center", gap: "4px",
                  fontSize: "11px", fontWeight: 600,
                  background: "#eef2ff", color: "#6366f1",
                  borderRadius: "6px", padding: "3px 8px",
                  textDecoration: "none", maxWidth: "160px",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}
              >
                📎 {att.original_name}
              </a>
            ))}
          </div>
        )}

        <div style={{
          fontSize: "10px", color: "#9ca3af",
          marginTop: "4px",
          textAlign: isMine ? "right" : "left",
        }}>
          {formatTime(message.created_at)}
        </div>
      </div>
    </div>
  );
};

export default SupportMessage;
